import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../actionTypes'
import JobListing from '../components/JobListing'
import Breadcrumbs from '../components/Breadcrumbs'
import { Grid, Box, makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  topBox: {
    backgroundColor: `#FFF`,
    padding: `2.5rem 8.125rem 1rem`,
    width: `100%`,
  },
  breadcrumbs: {},
  breadcrumbLink: {
    color: `#1E2553`,
    textDecoration: `none`,
    '&:hover': {
      textDecoration: `none`,
    },
  },
  breadcrumbDivider: {
    color: `#009ECC`,
    display: `inline`,
  },
  backButton: {
    color: `#1E2553`,
    display: `block`,
    fontSize: `1.5rem`,
    marginTop: `1rem`,
    textDecoration: `none`,
    textTransform: `uppercase`,
    '&:hover': {
      textDecoration: `none`,
    },
  },
  bottomBox: {
    backgroundColor: `#FFF`,
    margin: `0 auto 7.5rem`,
    maxWidth: `92.5%`,
    width: `92.5%`,
    padding: `3rem 0`,
    [theme.breakpoints.up('sm')]: {
      margin: `4rem auto 11.5rem`,
      maxWidth: `80%`,
      width: `80%`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `4rem auto 17.625rem`,
      maxWidth: `80rem`,
      width: `70%`,
    },
  },
  section: {
    padding: `0 2rem`,
    [theme.breakpoints.up('sm')]: {
      padding: `0 4rem`,
    },
    [theme.breakpoints.up('md')]: {
      padding: `0 8rem`,
    },
  },
  overview: {
    borderBottom: `1px solid #EEE`,
  },
  overviewParagraph: {
    fontSize: `0.875rem`,
    lineHeight: `1.5rem`,
  },
  overviewBottom: {
    marginBottom: `2rem`,
  },
  header: {
    color: `#1E2553`,
  },
  h2: {
    fontSize: `1.75rem`,
    margin: `1rem 0`,
  },
  h3: {
    fontSize: `1rem`,
    margin: `2rem 0`,
    textTransform: `uppercase`,
  },
  jobBottom: {
    borderTop: `1px solid #EEE`,
    display: `flex`,
    justifyContent: `flex-end`,
    marginTop: `3rem`,
    padding: `2rem`,
    paddingBottom: `0`,
    [theme.breakpoints.up('md')]: {
      marginTop: `8rem`,
    },
  },
  jobDetails: {
    color: `#FFFFFF`,
    cursor: `pointer`,
    backgroundColor: `#1E2553`,
    padding: `0.5625rem 2.5rem`,
    textAlign: `center`,
    textDecoration: `none`,
    width: `100%`,
    '&:hover': {
      textDecoration: `none`,
    },
    [theme.breakpoints.up('md')]: {
      width: `auto`,
    },
    borderRadius: '3px',
    boxShadow: '0 2px 2px #70707066',
  },
}))

const ListingPage = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { project } = useSelector((state) => state.listing)

  let id = props.match.params.id

  const getProject = useCallback(
    (id) => {
      dispatch({
        type: actions.LISTING_PROJECT_REQUEST,
        payload: { id },
      })
    },
    [dispatch]
  )

  useEffect(() => {
    window.scrollTo(0, 0)
    getProject(id)
  }, [getProject, id])

  return (
    <Grid container>
      {project && (
        <Breadcrumbs
          crumbs={[{ text: `${project.topic}`, path: `/listing/${props.match.params.id}` }]}
        />
      )}
      {project && (
        <>
          <JobListing
            job={{
              id: props.match.params.id,
              title: project.topic,
              date: project.creation_datetime,
              description: project.project_description,
              type: project.position_type,
              dept: project.department,
              topic: project.division,
              attending: project.attending,
              email: project.email,
            }}
            listingPage
          />
          <Box className={classes.bottomBox}>
            <Box className={clsx(classes.section, classes.overview)}>
              <h2 className={clsx(classes.header, classes.h2)}>Overview</h2>
              <p className={classes.overviewBottom}>{project.project_description}</p>
            </Box>
            {project.qualifications && (
              <Box className={classes.section}>
                <h3 className={clsx(classes.header, classes.h3)}>Qualifications</h3>
                <p>{project.qualifications}</p>
              </Box>
            )}
            <Grid item xs={12} className={classes.jobBottom}>
              <a
                href={`mailto:${project.email}`}
                className={classes.jobDetails}
                target="_blank"
                rel="noopener noreferrer"
              >
                APPLY NOW
              </a>
            </Grid>
          </Box>
        </>
      )}
    </Grid>
  )
}

export default ListingPage
